﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { useServerContext } from "~base/Services/ServerContext";
import CustomerStartPage from "../CustomerStart";
import StartPage from "~base/Pages/Home/Start";
import StartPageCustomization from "~jrad/Pages/Home/Start";

/**
 * StartPage selector based on the user's role (custom page for customers, standard page for advisors and admins)
 */
export const StartPageSwitch: React.FC = () => {
    const serverContext = useServerContext();

    const hasLoadedContext = !!serverContext.user;

    if (hasLoadedContext) {
        const roles = serverContext.user.Roles;

        if (
            roles.filter(
                (role) =>
                    role.Name === "customer" || role.Name == "customeranonymous"
            ).length > 0
        ) {
            return <CustomerStartPage />;
        } else {
            return <StartPage customizations={StartPageCustomization} />;
        }
    }

    return null;
};
